import { useEffect, useCallback } from 'react';
import qs from 'qs';
import { useMutation } from '@apollo/react-hooks';

import { useSetToken } from '../modules/auth/actions';
import AuthConfirm from '../graphql/AuthConfirm';


export default () => {
  const setToken = useSetToken(),
        [confirmCode, { data, loading }] = useMutation(AuthConfirm);

  const triggerAction = useCallback(async (url) => {
    if (!url) {
      return;
    }

    const [, queryPart] = url.split('?');
    if (queryPart) {
      const { email, code } = qs.parse(queryPart);

      if (email && code && !loading) {
        await confirmCode({ variables: { email, code } });
      }
    }
  }, [confirmCode, loading]);

  useEffect(() => {
    if (data && data.authConfirm) {
      setToken(data.authConfirm);
    }
  }, [data, setToken]);

  return triggerAction;
};
